import { defineMessages } from 'react-intl'

export default defineMessages({
    incompleteTitle: {
        id: 'containers.CustomerPage.RequiredFields.incomplete',
        defaultMessage: 'The following information is required',
    },
    completeTitle: {
        id: 'containers.CustomerPage.RequiredFields.complete',
        defaultMessage: 'All required fields have been inserted.',
    },
    completeSubTitle: {
        id: 'containers.CustomerPage.RequiredFields.completeSubTitle',
        defaultMessage: 'Click "Complete customer setup" to invite and activate the customer. You can add more information later.',
    }
})
